export class FullPageOverlay {

    constructor() {
        this.element = document.querySelector('.js-full-page-overlay');
    }
    show () {
        this.element.classList.remove('is-hidden');
    }
    hide () {
        this.element.classList.add('is-hidden');
    }

}
